import { configureStore } from '@reduxjs/toolkit';
// Import redux-saga through wrapper for Metro bundler compatibility
import createSagaMiddleware from './reduxSagaWrapper';

import { notificationsReducer } from './slices/notificationsSlice';
import { authReducer } from './slices/authSlice';
import rootSaga from './sagas/rootSaga';

const sagaMiddleware = createSagaMiddleware();

export const store = configureStore({
    reducer: {
        auth: authReducer,
        notifications: notificationsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ thunk: false }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;